<template>
  <div>
    <template v-if="count">
      <div v-for="v in list" :key="`card-add-record-${v.id}`" class="item-box">

        <div class="item-content border-bottom">
          <div class="record-list-item flex-justify-between">
            <div class="record-list-title">{{ v.card_ticket_type_name }}</div>
            <div class="time accent-color">{{ v.add_time | timeToYmdHi }}</div>
          </div>
          <div class="record-list-item">
            课次券 ID：「<span class="success-color user-select">{{ v.card_ticket_id }}</span>」；
            仅限新生办理（办理时）：「<span v-if="v.is_new" class="success-color">是</span><span v-else class="danger-color">否</span>」；
            有效天数：「<span class="success-color">{{ v.expire_days | toYuan }}</span> 天」；
            有效次数：「<span class="success-color">{{ v.expire_number | toYuan }}</span> 次」；
            <template v-if="!v.card_id">过期时间：「<span class="success-color">{{ v.expire_time | timeToYmdHis }}</span>」；</template>

            <template v-if="v.card_id">
              付款方式：「<span class="success-color">办卡附赠</span>」；
              所属课卡：「<router-link :to="RouteConfig.cardDetail.to(v.card_id)" class="primary-color">{{ v.card_name }}</router-link>」；
              所属课卡ID：「<span class="success-color user-select">{{ v.card_id }}</span>」；
            </template>
            <template v-else>
              付款方式：「<span class="success-color">{{ v.card_payment_mode_name }}</span>」；
              原价：「<span class="success-color">{{ v.price_original | toYuan }}</span> 元」；
              实际价格：「<span class="success-color">{{ v.price | toYuan }}</span> 元」；
              <template v-if="v.you_zan_number">
                有赞券码：「<span class="success-color">{{ v.you_zan_number }}</span>」；
                有赞核销金额：「<span class="success-color">{{ v.you_zan_payment | toYuan }}</span> 元」；
              </template>
              实际付款：「<span class="danger-color bolder">{{ v.actual_payment | toYuan }}</span> 元」；
              单次课消：「<span class="success-color">{{ v.unit_price | toYuan }}</span> 元」；
              付款凭证：「<a v-if="v.receipt" class="primary-color" :href="v.receipt" target="_blank">{{ v.receipt }}</a><span v-else class="info-color">未上传</span>」；
              付款备注：「<span v-if="v.payment_remark" class="danger-color">{{ v.payment_remark }}</span><span v-else class="info-color">未填写</span>」；
              备注文件：「<a v-if="v.remark_file" class="primary-color" :href="v.remark_file" target="_blank">{{ v.remark_file }}</a><span v-else class="info-color">未上传</span>」；
              课消：「<span class="success-color">{{ v.unit_price | toYuan }}</span> 元」。
            </template>

          </div>
          <div class="store-name accent-color">
            <template v-if="v.add_administrator_id">
              <span class="operator">办理人：{{ v.add_administrator_nickname || '未知管理员' }}</span>
              办理人所属门店：{{ v.store_name }}
            </template>
            <span v-else class="operator">办理人：学员本人于小程序购买</span>
          </div>
        </div>
      </div>

      <div v-if="count" class="pagination-box">
        <el-pagination
          :background="true"
          :current-page.sync="page"
          :page-size.sync="size"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="pageSizes"
          :total="count"
          @size-change="handlePageChange"
          @current-change="handlePageChange"
        />
      </div>
    </template>
    <div v-else class="empty-tip-box">暂无办卡记录</div>
  </div>
</template>

<script>
import scrollTo from "@/utils/scroll-to";
import { getAddRecords } from "@/api/card-ticket";
import RouteConfig from "@/router/config";

export default {
  props: {
    studentId: Number,
  },
  data: () => ({
    RouteConfig,
    list: [],
    count: 0,
    page: 1,
    size: 8,
    pageSizes: [10, 20, 30],
  }),
  methods: {
    async getList() {
      const { isError, data } = await getAddRecords({
        student_id: this.studentId,
        page: this.page,
        size: this.size,
      });
      if (isError) return;

      this.list = data.list;
      this.count = data.count;
    },
    handlePageChange() {
      this.getList();
      scrollTo(0, 350);
    },
  },
  beforeMount() {
    this.getList();
  },
};
</script>

<style src="@/components/student-detail-record.css" scoped/>
